import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { getBackgroundColor } from 'src/utils';

const CommittedTotalAmountCell: FC<GridCellProps> = (props: GridCellProps) => {
  const { setCommittedAmountData, toggleExpand } = useViewCheckbook();
  const { value, displayValue } = useGridCellDisplayValue(props);

  const handleClick = useCallback(() => {
    setCommittedAmountData((prev) =>
      [...prev].map((item) => {
        if (item?.rowId === props.dataItem.rowId) {
          item.expanded = !props.dataItem.expanded;
        }
        return item;
      })
    );
    toggleExpand();
  }, [props.dataItem.expanded, props.dataItem.rowId, setCommittedAmountData, toggleExpand]);
  return (
    <GridCellBase
      {...props}
      style={getBackgroundColor(value)}
      title={displayValue}
      className="!text-right"
    >
      <button onClick={handleClick} className="text-link cursor-pointer underline">
        <span>{displayValue}</span>
      </button>
    </GridCellBase>
  );
};

export default CommittedTotalAmountCell;
